import { render, staticRenderFns } from "./firstClaim.vue?vue&type=template&id=44e8f50e&scoped=true"
import script from "./firstClaim.vue?vue&type=script&lang=js"
export * from "./firstClaim.vue?vue&type=script&lang=js"
import style0 from "./firstClaim.vue?vue&type=style&index=0&id=44e8f50e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e8f50e",
  null
  
)

export default component.exports